export const trimSlashes = (value?: Maybe<string>): string =>
  (value ?? '').replace(/^\/+/, '').replace(/\/+$/, '');

export const slugify = (value?: Maybe<string>): string =>
  (value ?? '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const FILE_SIZE_UNITS = ['B', 'kB', 'MB', 'GB', 'TB'];

export const humanFileSize = (bytes?: Maybe<string | number>, decimals = 1): string => {
  const size = typeof bytes === 'string' ? Number(bytes) : bytes ?? 0;

  if (!size || Number.isNaN(size) || size < 0) return '';
  if (size < 1000) return `${size} ${FILE_SIZE_UNITS[0]}`;

  const exponent = Math.min(
    Math.floor(Math.log(size) / Math.log(1000)),
    FILE_SIZE_UNITS.length - 1
  );
  const scaled = size / Math.pow(1000, exponent);

  return `${scaled.toFixed(decimals)} ${FILE_SIZE_UNITS[exponent]}`;
};

export const HOME_URI = '__home__';

export const toRetourPaths = (uri?: Maybe<string>): string[] => {
  const path = `/${trimSlashes(uri)}`;

  return [`${path}/`, path];
};

export const parseHref = (value?: Maybe<string>): { href: string; external: boolean } => {
  const href = (value ?? '').trim();

  if (!href || href === HOME_URI || href === '/') return { href: '/', external: false };

  if (/^(https?:)?\/\//i.test(href)) return { href, external: true };
  if (/^[a-z][a-z0-9+.-]*:/i.test(href)) return { href, external: true };
  if (href.startsWith('#') || href.startsWith('?')) return { href, external: false };

  return { href: `/${trimSlashes(href)}/`, external: false };
};
